/**
 * @file Entry file for PickupBlockSelector Component
 * @author Mike Chacon
 */

import PickupBlockSelector from "./container";

export default PickupBlockSelector;
